export const lightMapStyle = "mapbox://styles/mpilarczykstarcount/clzjp5jdw00ky01qyc7qh4566"
export const darkMapStyle = "mapbox://styles/mpilarczykstarcount/clz1qpnfl00k301nvgt0qalb9"
